import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import { AdminProviders } from '../../UserSettings/Providers/Providers';
import ProvidersStats from '../../UserSettings/ProvidersStats/ProvidersStats';
import UploadTermsOfUse from '../../UserSettings/TermsOfUse/UploadTermsOfUse';
import GoogleStatistics from '../../GoogleStatistics/GoogleStatistics';
import AuditLogs from '../../UserSettings/Logs/Logs';
import ServicesStatus from '../../UserSettings/ServicesStatus/ServicesStatus';
import EmailsConfiguration from '../../UserSettings/EmailsConfiguration/EmailsConfiguration';
import Users from 'src/modules/UserSettings/Users/Users';
import { AdminManagers } from 'src/modules/Agencies/Manager/Add/Manager';
import { AdminManagerInfo } from 'src/modules/Agencies/Manager/View/components/ManagerInfo';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.PROVIDERS],
    component: AdminProviders,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.PROVIDERSSTATS],
    component: ProvidersStats,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.UPLOADTERMSOFUSE],
    component: UploadTermsOfUse,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.ADMINSTATS, routes.FINDSTATS, routes.ADMINSETTINGS],
    component: GoogleStatistics,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.AUDITLOGS],
    component: AuditLogs,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.LOGINLOGS],
    component: AuditLogs,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.RECOGNITIONLOGS],
    component: ServicesStatus,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.ETLLOGS],
    component: ServicesStatus,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.EMAILSCONFIGURATION],
    component: EmailsConfiguration,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.ADMINUSERS],
    component: Users,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.ADMINUSERSADD, routes.ADMINUSERSEDIT],
    component: AdminManagers,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.ADMINUSERSINFO],
    component: AdminManagerInfo,
    policies: [UserTypes.ADMIN]
  }
]);

export const adminModule = (): IRouteModule => ({
  name: RoutesModules.ADMIN,
  routes: moduleRoutes(),
  navbar: routes.ADMINSTATS,
  settingsNavbar: true,
  sidebar: [
    {
      navTitle: 'GMCNgine analytics',
      route: routes.ADMINSTATS
    },
    {
      navTitle: 'Find analytics',
      route: routes.FINDSTATS,
      hideOnMobile: true
    },
    {
      navTitle: 'Image providers',
      route: routes.PROVIDERS
    },
    {
      navTitle: 'Providers statistics',
      route: routes.PROVIDERSSTATS
    },
    {
      navTitle: 'Audit logs',
      route: routes.AUDITLOGS
    },
    {
      navTitle: 'Login logs',
      route: routes.LOGINLOGS
    },
    {
      navTitle: 'Upload terms of use',
      route: routes.UPLOADTERMSOFUSE,
      hideOnMobile: true
    },
    {
      navTitle: 'Recognition status',
      route: routes.RECOGNITIONLOGS,
      hideOnMobile: true
    },
    {
      navTitle: 'ETL status',
      route: routes.ETLLOGS,
      hideOnMobile: true
    },
    {
      navTitle: 'Emails configuration',
      route: routes.EMAILSCONFIGURATION,
      hideOnMobile: true
    },
    {
      navTitle: 'Users',
      route: routes.ADMINUSERS,
      hideOnMobile: true
    }
  ]
});